module.exports = __webpack_public_path__ + "ae449e7e8104c5084de5f763e44a145b.svg";